export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-ink text-white/80 border-t border-white/10"
    >
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <p className="font-display text-2xl font-black text-white">
            Artisan <span className="text-brand-rust font-medium">Contracting</span>
          </p>
          <p className="mt-4 text-sm leading-relaxed text-white/60 max-w-sm">
            Interior construction, remodeling, painting, flooring, tile, trim,
            doors, windows and drywall repair across Western New York.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-white/50">
            Services
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>Painting</li>
            <li>Flooring</li>
            <li>Tile Work</li>
            <li>Trim & Doors</li>
            <li>Drywall Repairs</li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-white/50">
            Contact
          </p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a
                href="tel:17165134765"
                data-testid="footer-phone-link"
                className="hover:text-brand-rust transition-colors"
              >
                716-513-4765
              </a>
            </li>
            <li>
              <a
                href="mailto:artisancontractingny@gmail.com"
                data-testid="footer-email-link"
                className="hover:text-brand-rust transition-colors break-all"
              >
                artisancontractingny@gmail.com
              </a>
            </li>
            <li className="text-white/60">
              Niagara Falls · Buffalo · Lockport · WNY
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Artisan Contracting. All rights reserved.</p>
          <p>Built with care in Western New York.</p>
        </div>
      </div>
    </footer>
  );
}
